import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import Spinner from "../lib/spinner";
import "./modal.scss";
import MediaPlayer from "../lib/media_player/media_player";

class AdPlacementsModal extends Component {
  constructor(props) {
    super(props);
    this.savePlacements = this.savePlacements.bind(this);
  }

  componentDidMount() {
    this.props.clearForm(this.props.episode);
  }

  componentDidUpdate() {
    if (this.props.isSuccess) {
      this.props.closeModal();
    }
  }

  render() {
    return (
      <div className="static-modal">
        <Modal.Dialog className="seedcast-modal">
          <Spinner isLoading={this.props.isLoading} />
          <Modal.Header>
            <Modal.Title>Change Ad Placements</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div>
              <MediaPlayer
                setCursor={this.props.setCursor}
                mediaFileUUID={this.props.episode && this.props.episode.contentMediaFileUUID}
                user={this.props.user}
                fetchMediaFile={this.props.fetchMediaFile}
                mediaFiles={this.props.mediaFiles}
              />
            </div>
            <div>
              <Button
                className="ad-placement-modal__create-placement"
                onClick={() => {
                  this.props.setPlacement(this.props.cursor);
                }}>
                Create Placement Here
              </Button>
              <ul>
                {this.props.placements.sort().map((placement, i) => {
                  return (
                    <li key={i}>
                      <span
                        onClick={() => {
                          this.props.deletePlacement(i);
                        }}
                        className="ad-placement-delete-button glyphicon glyphicon-remove"
                      />
                      <span className="ad-placement-modal__placement-info">{placement / 1000}</span>
                    </li>
                  );
                })}
              </ul>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button onClick={this.props.closeModal}>Cancel</Button>
            <Button
              className="ad-placement-modal__save-button"
              bsStyle="primary"
              onClick={this.savePlacements}>
              Save
            </Button>
          </Modal.Footer>
        </Modal.Dialog>
      </div>
    );
  }

  savePlacements() {
    this.props.savePlacements(this.props.episode.uuid, this.props.placements, this.props.user);
  }
}

export default AdPlacementsModal;
